import React, { useCallback, useContext, useEffect, useState } from 'react';

import Loader from '@common/components/loader';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { PAYMENT_SERVICES } from '@app/dev/constants/enums/paymentServices';
import ToastWrapper from '@common/helpers/toastWrapper';

import './style.scss';

export const DepositByPix = ({
  amount,
  depositMethod
}) => {
  const t = useTranslation();
  const [qrIframeUrl, setQrIframeUrl] = useState();
  const [{ closePopup }] = useContext(PopupContext);

  const getQrUrl = useCallback(async () => {
    try {
      const req = {
        amount: +amount,
        service: PAYMENT_SERVICES[depositMethod.service],
        payer: {
          forProduct: 'sport',
        },
      }
  
      if (PAYMENT_SERVICES[depositMethod.service] === PAYMENT_SERVICES.SAFEWAY)
        req.payer.Type = 3;
  
      const res = await swarmRequest(req, 'deposit_v2');
  
      if (res.status === 'error')
        return ToastWrapper('error', 'Something went wrong while getting qr code')
  
      const iframeUrl = res.action;
  
      setQrIframeUrl(iframeUrl);
    } catch (ex) {
      console.log(ex, 'dsf')
    }
  }, [setQrIframeUrl, amount, depositMethod.service]);

  useEffect(() => {
    getQrUrl();
  }, [getQrUrl]);

  return (
    <div className={`popup-content ${depositMethod.name}`}>
      <h3 className="popup-title">{t('Deposit')}</h3>
      <div className="popup-main-content">
        {
          qrIframeUrl
            ? <iframe src={qrIframeUrl} />
            : <Loader />
        }
      </div>
      <button
        className="popup-cancel-button"
        onClick={closePopup}
      >
        {t('Close')}
      </button>
    </div>
  );
};
